import { PROFILES } from "../../../../assets/profiles/profiles";
import { PROD_CLIENT_LIST } from "../../../interfaces/ClientGlobalInterface.type";
import { icon } from "leaflet";

/** Static navbar menu tree. Profile and client lists on each entry are applied at runtime by NavbarMenuService. */
export const MENU = [
  // ANCHOR Main
  {
    name: "main",
    link: "/principal-agrupacion",
    icon: "fa fa-home fa-fw",
    profile: [
      PROFILES.USUARIO_CLIENTE,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.USUARIO_TELEMEDIDA
    ],
  },
  // ANCHOR Global main
  {
    name: "main",
    link: null,
    icon: "fas fa-home fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.ADMIN_ENTIDAD
    ],
    submenu: [
      {
        name: "agrupation",
        link: "/principal-agrupacion",
        icon: "fa fa-fw fa-map",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_ENTIDAD
        ]
      },
      {
        name: "client-management",
        link: "/principal-entidades",
        icon: "fas fa-sitemap",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON, PROFILES.ADMIN_CLIENTE]
      },
      {
        name: "client-summary",
        link: "/principal-global",
        icon: "fas fa-globe",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_ENTIDAD
        ]
      }
    ]
  },

  // ANCHOR Telecontrol
  {
    name: "telecontrol",
    link: null,
    icon: "fas fa-binoculars fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.TELEMEDIDA,
      PROFILES.USUARIO_TELEMEDIDA
    ],
    submenu: [
      // Alert panel
      {
        name: "telecontrol-panel",
        link: "/telecontrol/alertas-activas",
        icon: "fas fa-exclamation-circle fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.ADMIN_AGRUPACION,
          PROFILES.USUARIO_AGRUPACION
        ],
      },
      // Historic
      {
        name: "telecontrol-historic",
        link: "/telecontrol/historico",
        icon: "fas fa-calendar-alt fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.ADMIN_AGRUPACION,
          PROFILES.USUARIO_AGRUPACION
        ],
      },
      // Entity alert configuration
      {
        name: "entity-alerts-config",
        link: "/alarmas/entidad/configuracion",
        icon: "fas fa-sitemap fa-fw",
        subicon: "fas fa-cog fa-fw",
        profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
      },
      // Telemetry
      {
        name: "telemetry",
        link: "/telecontrol/telemedida",
        icon: "fas fa-tachometer-alt fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.TELEMEDIDA,
          PROFILES.USUARIO_TELEMEDIDA
        ],
        client: [PROD_CLIENT_LIST.NORTEGAS],
        disabled: "isTlm",
      },
      // Test devices
      {
        name: "test-devices",
        link: "/telecontrol/test",
        icon: "fas fa-list-check fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.TELEMEDIDA
        ],
        disabled: "isTlm",
        client: [PROD_CLIENT_LIST.NORTEGAS],
      },
      // DataLoggers
      {
        name: "plums-in-network",
        link: "/telecontrol/dataloggers",
        icon: "fas fa-clipboard-list fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.TELEMEDIDA,
          PROFILES.USUARIO_TELEMEDIDA
        ],
        client: [PROD_CLIENT_LIST.NORTEGAS],
      },
      // Network
      {
        name: "network-scheme",
        link: "/telecontrol/esquema-red",
        icon: "fas fa-timeline fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_ENTIDAD
        ],
      }
    ]
  },
  // ANCHOR Gateways
  {
    name: "gateways",
    link: null,
    icon: "gateway-icon",
    profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
    submenu: [
      // Installed
      {
        name: "installed-gateway",
        link: "/gateways/listado/asignados",
        icon: "fas fa-circle-nodes fa-fw",
        profile: [],
      },
      // Pending
      {
        name: "available",
        link: "/gateways/listado/disponibles",
        icon: "fas fa-clipboard-check fa-fw",
        profile: [],
      },
      // Inactive
      {
        name: "in-stock",
        link: "/gateways/listado/en-stock",
        icon: "fas fa-warehouse fa-fw",
        profile: [],
      },
      // Faulty
      {
        name: "damaged",
        link: "/gateways/listado/averiados",
        icon: "fas fa-times-circle fa-fw",
        profile: [],
      },
      // Repair
      {
        name: "repair",
        link: "/gateways/listado/reparacion",
        icon: "fas fa-tools fa-fw",
        profile: [],
      },
      // APP EUI
      {
        name: "App EUI",
        link: "/gateways/appeui",
        icon: "fas fa-broadcast-tower fa-fw",
        profile: [],
      }
    ]
  },
  // ANCHOR Maintenance
  {
    name: "management",
    link: null,
    icon: "fas fa-tools fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.USUARIO_TELEMEDIDA
    ],
    submenu: [
      // Global
      {
        name: "global",
        link: null,
        icon: "fas fa-globe fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.ADMIN_AGRUPACION,
          PROFILES.USUARIO_AGRUPACION,
          PROFILES.USUARIO_TELEMEDIDA
        ],
        submenu: [
          // Gateways
          {
            name: "gateways",
            link: "/mantenimiento/global/gateways",
            icon: "gateway-submenu-icon",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Gateways battery
          {
            name: "battery-load",
            link: "/mantenimiento/global/bateria",
            icon: "gateway-submenu-icon",
            subicon: "fas fa-bolt",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Queued commands
          {
            name: "commands-tail",
            link: "/mantenimiento/global/cola-comandos",
            icon: "fas fa-terminal fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Concentrators
          {
            name: "concentrators",
            link: "/mantenimiento/global/concentradores",
            icon: "fas fa-tint fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // NB-IoT frames
          {
            name: "nbiot-frames",
            link: "/mantenimiento/global/tramas-nbiot",
            icon: "fas fa-list-alt fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // CUPS with multiple meters
          {
            name: "cups-multiple-devices",
            link: "/mantenimiento/global/cups-multiples-dispositivos",
            icon: "fas fa-tachometer-alt fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON, PROFILES.ADMIN_CLIENTE],
          },
          // Alarms
          {
            name: "alarms",
            link: "/mantenimiento/global/alarmas",
            icon: "fas fa-exclamation-triangle fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Incidents
          {
            name: "incidents",
            link: "/mantenimiento/global/incidencias",
            icon: "fas fa-info-circle fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Activations
          {
            name: "mix-date",
            link: "/mantenimiento/global/activaciones",
            icon: "fas fa-clipboard-list fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_ENTIDAD
            ],
          },
          // Searches
          {
            name: "search-global",
            link: "/mantenimiento/global/busqueda-global",
            icon: "fas fa-search fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.USUARIO_CLIENTE,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.USUARIO_ENTIDAD,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ],
          },
          // Search by model
          {
            name: "search-by-model",
            link: "/mantenimiento/global/busqueda-por-modelo",
            icon: "fas fa-industry fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Groups with custom alarms
          {
            name: "agrupations-with-custom-alarms",
            link: "/mantenimiento/global/agrupations-with-custom-alarms",
            icon: "fas fa-bell fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Users
          {
            name: "users",
            link: "/mantenimiento/global/usuarios",
            icon: "fas fa-users  fa-fw",
            profile: [PROFILES.ARSON],
            hideForDemo: true,
          },
          // Users (client)
          {
            name: "users-client",
            link: "/mantenimiento/global/usuarios-cliente",
            icon: "fas fa-users  fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON, PROFILES.ADMIN_CLIENTE],
          },
          // User events
          {
            name: "user-events",
            link: "/mantenimiento/global/eventos-usuario",
            icon: "fas fa-user fa-fw",
            subicon: "fas fa-calendar-day",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Communications report
          {
            name: "communication-report",
            link: "/mantenimiento/global/reporte-comunicaciones",
            icon: "fas fa-satellite-dish fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          }
        ]
      },
      // Entity
      {
        name: "entity",
        link: null,
        icon: "fas fa-sitemap fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.ADMIN_CLIENTE
        ],
        submenu: [
          // Gateways
          {
            name: "gateways",
            link: "/mantenimiento/entidad/gateways",
            icon: "gateway-submenu-icon",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Gateways
          {
            name: "gateways-client",
            link: "/mantenimiento/entidad/gateways-cliente",
            icon: "gateway-submenu-icon",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              ,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE
            ],
          },
          // Entity concentrators
          {
            name: "concentrators",
            link: "/mantenimiento/entidad/concentradores",
            icon: "fas fa-tint fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE
            ],
          },
          // Network
          {
            name: "network-optimization",
            link: "/mantenimiento/entidad/optimizar-red",
            icon: "fas fa-rocket fa-fw",
            profile: [PROFILES.ARSON],
          },
          // Entity data deletion
          {
            name: "entity-data-erase",
            link: "/mantenimiento/entidad/borrado-datos",
            icon: "fas fa-eraser fa-fw",
            profile: [PROFILES.ARSON],
          },
          // Group edition
          {
            name: "agrupations-edition",
            link: "/mantenimiento/entidad/editar-agrupaciones",
            icon: "fas fa-draw-polygon fa-fw",
            profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
          }
        ]
      },
      // Management
      {
        name: "internal-configuration",
        link: null,
        icon: "fas fa-cog fa-fw",
        profile: [PROFILES.ARSON],
        submenu: [
          // Cron
          {
            name: "Cron",
            link: "/mantenimiento/configurar/cron",
            icon: "fas fa-clock fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Blocked IPs
          {
            name: "IP",
            link: "/mantenimiento/configurar/ip",
            icon: "fas fa-ethernet fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Manufacturer management
          {
            name: "manufacturer",
            link: "//mantenimiento/configurar/fabricantes",
            icon: "fas fa-industry fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          }
        ]
      },
      // External config (LNS / TPE / Zeus / Push)
      {
        name: "external-configuration",
        link: null,
        icon: "fas fa-share-nodes fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
        submenu: [
          // LNS Global
          {
            name: "lns-configuration",
            link: "/mantenimiento/global/config-externa/lns",
            icon: "custom-lns-icon",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // TPE Global
          {
            name: "tpe-configuration",
            link: "/mantenimiento/global/config-externa/tpe",
            icon: "custom-actility-icon",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Zeus Global
          {
            name: "zeus-configuration",
            link: "/mantenimiento/global/config-externa/zeus",
            icon: "fas fa-bolt fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Push Global
          {
            name: "push-configuration",
            link: "/mantenimiento/global/config-externa/push",
            icon: "fas fa-paper-plane fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // External API Global
          {
            name: "external-api-configuration",
            link: "/mantenimiento/global/config-externa/api-externa",
            icon: "fas fa-plug fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          }
        ]
      },
      // Communications state
      {
        name: "communications-state",
        link: "/mantenimiento/estado-comunicaciones",
        icon: "fas fa-tower-cell",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON]
      },
      // Network builder
      {
        name: "supply-network-constructor",
        link: "/mantenimiento/construccion-de-red",
        icon: "fas fa-timeline fa-fw",
        profile: [PROFILES.ARSON]
      },
      // Supervisor
      {
        name: "entity-supervisor",
        link: null,
        icon: "fas fa-tv fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
        submenu: [
          // Create/edit supervisor
          {
            name: "entity-supervisor-edit",
            link: "//mantenimiento/monitorizacion/fiscalizador-editar",
            icon: "fas fa-edit",
            profile: [PROFILES.ARSON]
          },
          // Supervisor view
          {
            name: "entity-supervisor-show",
            link: "//mantenimiento/monitorizacion/fiscalizador-mostrar",
            icon: "fas fa-table",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON]
          }
        ]
      }
    ]
  },
  // ANCHOR Coverage
  {
    name: "coverage",
    link: null,
    icon: "fa fa-signal fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.ADMIN_CLIENTE
    ],
    submenu: [
      // Coverage test
      {
        name: "coverage-test",
        link: "/cobertura/test",
        icon: "fa fa-clipboard-check fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.ADMIN_CLIENTE
        ],
      },
      // Coverage map
      {
        name: "coverage-map",
        link: "/cobertura/mapa",
        icon: "fas fa-map-marked-alt fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
      },
      // MBus coverage map
      {
        name: "coverage-map-mbus",
        link: "/cobertura/mapa-mbus",
        icon: "fas fa-map-marked-alt fa-fw",
        subicon: "fas fa-tint fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
      }
    ]
  },
  // ANCHOR Data management
  {
    name: "custom-data",
    link: null,
    icon: "fas fa-database fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.USUARIO_TELEMEDIDA
    ],
    submenu: [
      // CUPS
      {
        name: "cups-list",
        link: "/gestion-datos/cups/listado",
        icon: "fas fa-clipboard-list fa-fw",
        subicon: "cups-submenu-icon",
        profile: [
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.USUARIO_AGRUPACION,
          PROFILES.USUARIO_TELEMEDIDA
        ],
      },
      // Meter information
      {
        name: "list-assigned",
        link: "/gestion-datos/informacion",
        icon: "fas fa-tachometer-alt fa-fw",
        profile: [
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.USUARIO_AGRUPACION,
          PROFILES.USUARIO_TELEMEDIDA
        ],
      },
      // Data configuration (client level)
      {
        name: "client-configuration-template",
        link: "/gestion-datos/configuracion-cliente",
        icon: "fas fa-user-tie fa-fw",
        subicon: "fas fa-cog fa-fw",
        profile: [PROFILES.ARSON, PROFILES.ADMIN_CLIENTE],
        visible: "globalManagement",
      },
      // Data configuration
      {
        name: "data-config",
        link: "/gestion-datos/configuracion",
        icon: "fas fa-cog fa-fw",
        profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
      },
      // PTA list
      {
        name: "pta-redgis",
        link: "/gestion-datos/pta-redgis",
        icon: "fas fa-link fa-fw",
        profile: [PROFILES.ARSON, PROFILES.ADMIN_CLIENTE],
        client: [PROD_CLIENT_LIST.NORTEGAS],
      },
      // Metrology
      {
        name: "metrological",
        icon: "fas fa-clipboard-list fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_AGRUPACION
        ],
        visible: "gas",
        submenu: [
          {
            name: "configuration",
            link: "/gestion-datos/metrologia/configuracion",
            icon: "fas fa-cog fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION
            ],
          },
          {
            name: "list",
            link: "/gestion-datos/metrologia/listado",
            icon: "fas fa-clipboard-list fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION
            ],
          }
        ]
      },
      {
        name: "meters-info",
        link: null,
        icon: "fas fa-tachometer-alt fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.ADMIN_CLIENTE
        ],
        visible: "!entityCupsConf",
        submenu: [
          // Meter information
          {
            name: "list",
            link: "/gestion-datos/informacion",
            icon: "fas fa-clipboard-list fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE
            ],
          },
          // Meter import
          {
            name: "import",
            link: "/gestion-datos/importar/contadores",
            icon: "fas fa-file-arrow-up fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION
            ],
            disabled: "!extraData",
          }
        ]
      },
      {
        name: "cups-info",
        link: null,
        icon: "fas fa-location-dot fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_AGRUPACION,
          PROFILES.USUARIO_TELEMEDIDA
        ],
        visible: "entityCupsConf",
        submenu: [
          // CUPS
          {
            name: "cups-list",
            link: "/gestion-datos/cups/listado",
            icon: "fas fa-clipboard-list fa-fw",
            subicon: "cups-submenu-icon",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ],
          },
          // CUPS installed
          {
            name: "meter-in-cups-installation-list",
            link: "/gestion-datos/cups/listado-instalados",
            icon: "fas fa-tachometer-alt fa-fw",
            subicon: "cups-submenu-icon",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ],
          },
          // Meter information
          {
            name: "list-assigned",
            link: "/gestion-datos/informacion",
            icon: "fas fa-tachometer-alt fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ],
          },
          // CUPS import
          {
            name: "import",
            link: "/gestion-datos/importar/cups",
            icon: "fas fa-file-arrow-up fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION
            ],
          },
          // PTA import
          {
            name: "pta-import-fix",
            link: "/gestion-datos/pta",
            icon: "fas fa-file-arrow-up fa-fw",
            profile: [PROFILES.ARSON, PROFILES.ADMIN_CLIENTE],
            client: [PROD_CLIENT_LIST.NORTEGAS],
          },
          // Device substitution
          {
            name: "meter-substitution",
            link: "/dispositivos/sustituir/",
            icon: "fas fa-exchange-alt fa-fw",
            profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
          },
          // Notifications
          {
            name: "notifications",
            link: "/gestion-datos/cups/notificaciones",
            icon: "fas fa-bell  fa-fw",
            disabled: "cups",
            profile: [
              PROFILES.ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION
            ],
          },
          {
            name: "not-cups-assigned-devices",
            link: "/gestion-datos/cups/dispositivos-sin-cups",
            icon: "fas fa-ban fa-fw",
            subicon: "cups-submenu-icon",
            disabled: "cups",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ],
          }
        ]
      }
    ]
  },
  // ANCHOR Devices
  {
    name: "device",
    link: null,
    icon: "fas fa-tachometer-alt fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.ADMIN_INSTALLATION,
      PROFILES.TELEMEDIDA,
      PROFILES.USUARIO_TELEMEDIDA
    ],
    submenu: [
      // Lists
      {
        name: "lists",
        link: null,
        icon: "fas fa-clipboard-list fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.ADMIN_AGRUPACION,
          PROFILES.USUARIO_AGRUPACION,
          PROFILES.ADMIN_INSTALLATION,
          PROFILES.USUARIO_TELEMEDIDA
        ],
        submenu: [
          // In network
          {
            name: "in-network",
            link: "/dispositivos/listado/asignados",
            icon: "fas fa-circle-nodes fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.USUARIO_CLIENTE,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.USUARIO_ENTIDAD,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ],
          },
          // Pending
          {
            name: "pending",
            link: "/dispositivos/listado/no-asignados",
            icon: "fas fa-hourglass-half fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.USUARIO_CLIENTE,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.USUARIO_ENTIDAD,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ],
          },
          // Pending: client
          {
            name: "pending-client",
            link: "/dispositivos/listado/cliente",
            icon: "fa fa-user-tie fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON, PROFILES.ADMIN_CLIENTE],
            visible: "!globalManagement",
          },
          // Deactivated
          {
            name: "deactivated",
            link: "/dispositivos/listado/desactivados",
            icon: "fas fa-power-off fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.USUARIO_CLIENTE,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.USUARIO_ENTIDAD,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ],
          },
          // Review list
          {
            name: "annotations",
            link: "/dispositivos/listado/revision",
            icon: "fas fa-note-sticky fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ],
          },
          // Substitutions
          {
            name: "substitutions",
            link: "/dispositivos/listado/sustituciones",
            icon: "fas fa-exchange-alt fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.ADMIN_INSTALLATION
            ],
          },
          // Pending substitutions
          {
            name: "substitutions-pending",
            link: "/dispositivos/listado/sustituciones-pendientes",
            icon: "fas fa-exchange-alt fa-fw",
            subicon: "fas fa-hourglass-half fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.ADMIN_INSTALLATION
            ],
          },
          // Internal list
          {
            name: "internal-list",
            link: "/dispositivos/listado/interno",
            icon: "arson-submenu-icon",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Internal GPRS list
          {
            name: "internal-list-gprs",
            link: "/dispositivos/listado/interno-gprs",
            icon: "arson-submenu-icon",
            subicon: "fas fa-signal",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // No communication
          {
            name: "no-communication",
            link: "/dispositivos/listado/sin-comunicacion",
            icon: "fas fa-broadcast-tower fa-fw",
            subicon: "fas fa-xmark",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Activation error list
          {
            name: "activation-error-list",
            link: "/dispositivos/listado/error-activacion",
            icon: "fas fa-exclamation fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // Low battery
          {
            name: "low-battery-list",
            link: "/dispositivos/listado/bateria-baja",
            icon: "fas fa-battery-quarter fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // WalkBy MBUS
          {
            name: "walk-by",
            link: "/dispositivos/listado/walk-by",
            icon: "fas fa-road fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.USUARIO_CLIENTE,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.USUARIO_ENTIDAD,
              PROFILES.ADMIN_AGRUPACION,
              PROFILES.USUARIO_AGRUPACION,
              PROFILES.USUARIO_TELEMEDIDA
            ]
          },
          // Unknown MBUS devices
          {
            name: "unknown-devices",
            link: "/dispositivos/listado/desconocidos-mbus",
            icon: "fas fa-question fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.USUARIO_ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE
            ],
          },
          // Ignored
          {
            name: "meters-ignored",
            link: "/dispositivos/listado/dispositivos-ignorados",
            icon: "fas fa-eye-slash fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          }
        ]
      },
      // Imports
      {
        name: "imports",
        link: null,
        icon: "fas fa-file-upload fa-fw",
        profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
        submenu: [
          // Data preload
          {
            name: "data-preload",
            link: "/dispositivos/importar/datos",
            icon: "fas fa-tachometer-alt fa-fw",
            profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
          },
          // Readings import
          {
            name: "readings-import",
            link: "/dispositivos/importar/lecturas/",
            icon: "fas fa-calendar-alt fa-fw",
            profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
          },
          // Coordinates import
          {
            name: "coords-import",
            link: "/dispositivos/importar/coordenadas/",
            icon: "fas fa-map-marker-alt fa-fw",
            profile: [PROFILES.ARSON],
          },
          // Gauge import
          {
            name: "caliber-import",
            link: "/dispositivos/importar/calibre/",
            icon: "fas fa-ruler-horizontal fa-fw",
            profile: [PROFILES.ARSON],
          },
          // Custom text data import
          {
            name: "data-text-import",
            link: "/dispositivos/importar/texto/",
            icon: "fas fa-heading fa-fw",
            profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
          },
          // Image import
          {
            name: "images-import",
            link: "/dispositivos/importar/imagenes/",
            icon: "fas fa-image fa-fw",
            profile: [PROFILES.ARSON],
          },
          // Device deactivation
          {
            name: "deactivate",
            link: "/dispositivos/importar/desactivacion/",
            icon: "fas fa-power-off fa-fw",
            profile: [PROFILES.ARSON],
          }
        ]
      },
      // New
      {
        name: "new",
        link: "/dispositivos/nuevo",
        icon: "fas fa-plus fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.TELEMEDIDA
        ],
      },
      // SIM cards
      {
        name: "sim-management",
        link: null,
        icon: "fas fa-sim-card fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
        submenu: [
          {
            name: "sim-ek",
            link: "/dispositivos/sim",
            icon: "fas fa-sim-card fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          {
            name: "sim-lora",
            link: "/dispositivos/sims",
            icon: "fas fa-sim-card fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          }
        ]
      },
      {
        name: "mbus-manufacturers",
        link: null,
        icon: "fas fa-industry fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
        submenu: [
          // MBUS manufacturers
          {
            name: "common-key",
            link: "/dispositivos/fabricantes-mbus/clave-comun",
            icon: "fas fa-key fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          },
          // MBUS candidates
          {
            name: "private-key",
            link: "/dispositivos/fabricantes-mbus/clave-primaria",
            icon: "fas fa-key fa-fw",
            subicon: "fas fa-lock",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          }
        ]
      }
    ]
  },
  // ANCHOR Work orders
  {
    name: "meter-orders",
    icon: "fas fa-list-check fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.USUARIO_TELEMEDIDA,
      PROFILES.ADMIN_INSTALLATION
    ],
    submenu: [
      {
        name: "list",
        link: "/ordenes/listado",
        icon: "fas fa-clipboard-list fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.ADMIN_AGRUPACION,
          PROFILES.USUARIO_AGRUPACION,
          PROFILES.USUARIO_TELEMEDIDA,
          PROFILES.ADMIN_INSTALLATION
        ],
      },
      {
        name: "routes",
        link: "/ordenes/rutas",
        icon: "fas fa-road fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.USUARIO_TELEMEDIDA,
          PROFILES.ADMIN_INSTALLATION
        ],
      }
    ]
  },
  // ANCHOR Alarms
  {
    name: "alarms",
    link: null,
    icon: "fas fa-exclamation-triangle fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.USUARIO_TELEMEDIDA
    ],
    submenu: [
      {
        name: "global",
        icon: "fa fa-globe fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
        submenu: [
          // Show global alarms
          {
            name: "show-alarms-global",
            link: "/alarmas/global/listado",
            icon: "fa fa-globe fa-fw",
            profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
          }
        ]
      },
      {
        name: "agrupation",
        icon: "fa fa-fw fa-map",
        submenu: [
          // Show group alarms
          {
            name: "show-alarms",
            link: "/alarmas/agrupacion/listado",
            state: { dateRange: "month", showInactives: true },
            icon: "fa fa-map fa-fw",
            profile: [],
          },
          // Group alarm configuration
          {
            name: "agrupation-alarms-config",
            link: "/alarmas/agrupacion/configuracion",
            icon: "fas fa-map fa-fw",
            subicon: "fas fa-cog fa-fw",
            profile: [
              PROFILES.ARSON,
              PROFILES.ADMIN_ENTIDAD,
              PROFILES.ADMIN_CLIENTE,
              PROFILES.ADMIN_AGRUPACION
            ],
          }
        ]
      },
      {
        name: "entity",
        icon: "fas fa-sitemap fa-fw",
        profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
        submenu: [
          // Entity alarm template configuration
          {
            name: "entity-alarms-config",
            link: "/alarmas/entidad/plantilla",
            icon: "fas fa-sitemap fa-fw",
            subicon: "fas fa-cog fa-fw",
            profile: [PROFILES.ARSON, PROFILES.ADMIN_ENTIDAD, PROFILES.ADMIN_CLIENTE],
          }
        ]
      },
      {
        name: "meters-groups",
        icon: "fas fa-layer-group  fa-fw",
        profile: [PROFILES.ARSON],
        submenu: [
          {
            name: "alarms",
            link: "/alarmas/personalizadas/listado",
            state: { dateRange: "month", showInactives: true },
            icon: "fas fa-bell fa-fw",
            profile: [PROFILES.ARSON],
          },
          {
            name: "alarms-custom-config",
            link: "/alarmas/personalizadas/configuracion",
            icon: "fas fa-cog fa-fw",
            profile: [PROFILES.ARSON],
          }
        ]
      },
      // Meters with continuous alarms
      {
        name: "meters-with-alarms-continued",
        link: "/alarmas/dispositivos",
        icon: "fa fa-tachometer-alt fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
      }
    ]
  },
  // ANCHOR Data analysis
  {
    name: "data-analysis",
    link: null,
    icon: "fas fa-magnifying-glass-chart fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.USUARIO_TELEMEDIDA
    ],
    submenu: [
      // Meter associations
      {
        name: "meters-groups",
        link: "/analisis-datos/asociaciones",
        icon: "fas fa-layer-group  fa-fw",
        profile: [],
      },
      // Meter graph
      {
        name: "meter-graph",
        link: "/analisis-datos/grafica",
        icon: "fas fa-chart-area fa-fw",
        profile: [],
      },
      // Graph comparison
      {
        name: "graph-comparison",
        link: "/analisis-datos/comparativa-graficas",
        icon: "fas fa-chart-area fa-fw",
        subicon: "fas fa-arrows-left-right fa-fw",
        profile: [],
      },
      // Hydraulic balance
      {
        name: "hydraulic-balance",
        link: "/analisis-datos/balance",
        icon: "fas fa-balance-scale-left",
        profile: [],
      },
      // Advanced analytics
      {
        name: "advanced-analytics",
        link: "/analisis-datos/analitica-avanzada",
        icon: "fas fa-chart-area fa-fw",
        subicon: "fas fa-search fa-fw",
        profile: [],
      },
      // Consumption evolution
      {
        name: "consumption-evolution",
        link: "/analisis-datos/evolucion-consumo",
        icon: "fas fa-map fa-fw",
        subicon: "fas fa-clock fa-fw",
        profile: [],
      },
      // Queries
      {
        name: "queries-preset",
        link: "/analisis-datos/consultas",
        icon: "fas fa-database fa-fw",
        profile: [],
      },
      // Analytical models
      {
        name: "analytical-models",
        link: null,
        icon: "fas fa-brain fa-fw",
        profile: [PROFILES.ARSON],
        submenu: [
          // Edit
          {
            name: "patterns-edition",
            link: "/analisis-datos/modelos-analiticos/editar",
            icon: "fas fa-edit fa-fw",
            profile: [PROFILES.ARSON],
          },
          // Patterns
          {
            name: "patterns-list",
            link: "/analisis-datos/modelos-analiticos/patrones",
            icon: "fas fa-chart-area fa-fw",
            profile: [PROFILES.ARSON],
          },
          // Meter list
          {
            name: "patterns-meters-category",
            link: "/analisis-datos/modelos-analiticos/listado",
            icon: "fas fa-folder-tree fa-fw",
            profile: [PROFILES.ARSON],
          }
        ]
      }
    ]
  },
  // ANCHOR Output files
  {
    name: "output-file",
    link: null,
    icon: "fas fa-file-export fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.USUARIO_TELEMEDIDA
    ],
    submenu: [
      // Aqualia
      {
        name: "Aqualia",
        link: "/ficheros/aqualia",
        icon: "fa fa-file-download fa-fw",
        profile: [PROFILES.ARSON],
        client: [PROD_CLIENT_LIST.AQUALIA],
      },
      // File download
      {
        name: "file-download",
        link: "/ficheros/descarga",
        icon: "fa fa-file-download fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_AGRUPACION,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.USUARIO_AGRUPACION,
          PROFILES.USUARIO_TELEMEDIDA
        ],
      },
      // File templates
      {
        name: "file-template",
        link: "/ficheros/plantillas/listado",
        icon: "fa fa-file fa-fw",
        profile: [PROFILES.ARSON],
      },
      // Periodic export
      {
        name: "file-template-export",
        link: "/ficheros/plantillas/exportacion",
        icon: "fa fa-calendar-day fa-fw",
        profile: [PROFILES.ARSON],
      },
      // Periodic generation
      {
        name: "file-timer",
        link: "/ficheros/horarios",
        icon: "fa fa-clock fa-fw",
        profile: [PROFILES.ARSON],
      },
      // EK280
      {
        name: "ek-file-configuration",
        link: "/ficheros/ek280",
        icon: "fa fa-gauge fa-fw",
        subicon: "fa fa-clock fa-fw",
        profile: [PROFILES.ARSON],
      }
    ]
  },
  // ANCHOR Suspicions
  {
    name: "suspicions",
    link: "/sospechas",
    icon: "fas fa-comment-dots",
    disabled: "disabled",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.USUARIO_TELEMEDIDA
    ],
  },
  // ANCHOR Network state
  {
    name: "network-state",
    link: null,
    icon: "fas fa-info fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.ADMIN_AGRUPACION
    ],
    submenu: [
      // Global
      {
        name: "global",
        link: "/estado-red/global",
        icon: "fa fa-globe fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
      },
      // Entity
      {
        name: "entity",
        link: "/estado-red/entidad",
        icon: "fa fa-sitemap fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.ADMIN_CLIENTE
        ],
      },
      // Group
      {
        name: "groups",
        link: "/estado-red/agrupacion",
        icon: "fa fa-map fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_AGRUPACION
        ],
      },
      // KPIs
      {
        name: "KPIs",
        link: "/estado-red/kpis",
        icon: "fas fa-broadcast-tower",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.ADMIN_ENTIDAD
        ],
      },
      // Global summary
      {
        name: "total-devices",
        link: "/estado-red/resumen-global",
        icon: "fas fa-tachometer-alt fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
      }
    ]
  },
  // ANCHOR Sensors
  {
    name: "sensory",
    link: null,
    icon: "fas fa-wave-square fa-fw",
    profile: [
      PROFILES.ARSON,
      PROFILES.USUARIO_ARSON,
      PROFILES.ADMIN_CLIENTE,
      PROFILES.USUARIO_CLIENTE,
      PROFILES.ADMIN_ENTIDAD,
      PROFILES.USUARIO_ENTIDAD,
      PROFILES.ADMIN_AGRUPACION,
      PROFILES.USUARIO_AGRUPACION,
      PROFILES.USUARIO_TELEMEDIDA
    ],
    submenu: [
      // Leaks
      {
        name: "leaks-map",
        link: "/sensorica/fugas",
        icon: "fa fa-faucet-drip fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.ADMIN_AGRUPACION,
          PROFILES.USUARIO_AGRUPACION,
          PROFILES.USUARIO_TELEMEDIDA
        ],
      },
      // Pressure
      {
        name: "pressure-map",
        link: "/sensorica/presion",
        icon: "fa fa-tachometer-alt fa-fw",
        profile: [
          PROFILES.ARSON,
          PROFILES.USUARIO_ARSON,
          PROFILES.ADMIN_CLIENTE,
          PROFILES.USUARIO_CLIENTE,
          PROFILES.ADMIN_ENTIDAD,
          PROFILES.USUARIO_ENTIDAD,
          PROFILES.ADMIN_AGRUPACION,
          PROFILES.USUARIO_AGRUPACION,
          PROFILES.USUARIO_TELEMEDIDA
        ],
      },
      // Flow
      {
        name: "flow-map",
        link: "/sensorica/caudal",
        icon: "fa fa-water fa-fw",
        profile: [PROFILES.ARSON, PROFILES.USUARIO_ARSON],
      }
    ]
  }
];

/** Navbar menu entry with optional submenu, visibility and client filters. */
export class MenuItem {
  public name: string;
  public link: string;
  public icon: string;
  public subicon: string;
  public profile: string[];
  public client: number[];
  public disabled?: string | boolean;
  public submenu?: MenuItem[];
  public shortcut?: string;
  public visible?: boolean;
  public hidden?: boolean;
  public hideForDemo?: boolean;

  constructor() {
    this.name = null;
    this.link = null;
    this.icon = null;
    this.profile = null;
    this.client = null;
    this.disabled = null;
    this.visible = null;
    this.hidden = false;
    this.hideForDemo = false;
  }
}
